import { commitMutation,
  graphql } from 'react-relay';
import environment from '../../.';
import { basicMutationOnCompleted, onErrorMutation } from '../common/common';

const mutation = graphql`
    mutation UpdateDefaultFontMutation($value: String!, $fontSize: Int!, $unit: String!) {
      updateDefaultFont(value: $value, fontSize: $fontSize, unit: $unit) {
        ok
        error
      }
    }
  `;

export default ({
  value,
  fontSize,
  unit
}, done) => {
  const variables = {
    value,
    fontSize,
    unit
  };

  commitMutation(
    environment(),
    {
      mutation,
      variables,
      onCompleted: ({ updateDefaultFont }) => basicMutationOnCompleted(updateDefaultFont, done),
      onError: error => onErrorMutation(error, done)
    }
  );
};
